import { isPageHidden } from '../../utils/checkHiddenPage';
import { SCREEN } from '../../utils/constants';

import {
    appointmentChannelId,
    form,
    hiddenPages,
    isBookAppointment,
    isFlowForCalendar,
    isInInstantQuote,
    procedures,
    providers,
    selectedLocation,
    selectedProcedures,
    setIsInstantQuote,
    staffId,
    staffProcedures,
    setStaffId,
} from '../../utils/variables';
import { loadCategories } from '../../views/components/category';
import { loadProcedures } from '../../views/components/procedures';
import { loadProviderList } from '../../views/pages/providers';
import { selectLocation } from '../actions/locationActions';
import { renderContinueBtn } from '../actions/providerActions';
import { navigate } from './movePages';
import { patientContinueBtnHandler, patientListeners } from './patientListeners';
import { filterProcedures, handleProviderContinueBtn, handleSelectProvider, providerListeners } from './providersListeners';

export function locationListeners() {
    /* on select location*/
    document
        .querySelectorAll('.locations__container .location')
        .forEach((i) => {
            i.addEventListener('click', () => {
                const id = parseInt(i.getAttribute('data-location-id'));
                selectLocation(id);
            });
        });

    /* on click Continue after select location */
    document
        .querySelector('.locationContinue__btn')
        .addEventListener('click', async () => {
            handleLocationPage();
        });

    /* on click back button */
    document
        .querySelector('.locations__container .backOneStep__btn')
        .addEventListener('click', () => {
            setIsInstantQuote(false);
            document.querySelector('.no-preference-provider')?.classList?.add('hidden');
        });

    if (appointmentChannelId) {
        document
            .querySelector('.locations__container .backOneStep__btn').classList.add("hide")
    }
}


export const handleLocationPage = () => {
    if (isBookAppointment || appointmentChannelId) {
        const hostType = form?.appointment_channel?.host || 'one_on_one';
        const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
        const staffCount = staffsOfAppointmentChannel?.length || 0;
        const canChooseStaff = (hostType === 'one_on_one' && staffCount > 1) ||
            (hostType !== 'one_on_one' && form?.appointment_channel?.visitor_can_choose_the_staff);

        const isProviderFirst = form?.appointment_channel?.is_select_provider_first;
        if (appointmentChannelId && (canChooseStaff || form?.appointment_channel?.procedures?.length > 1)) {
            const { procedures } = form.appointment_channel
            const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking)
            const ids = staffsOfAppointmentChannel?.map(i => i.id)
            let listProvider = providers.filter(
                (provider) => ids.includes(provider.id)
            )
            listProvider = listProvider.filter(
                (provider) => provider.location_ids?.includes(selectedLocation)
            )

            if (!isProviderFirst && staffProcedures?.length) {
                const staffIds = staffProcedures?.map((sp) => sp?.staff_id) ?? []
                listProvider = listProvider.filter(({ id }) => staffIds.includes(id))
            }

            if (procedures?.length === 1 || (appointmentChannelId && selectedProcedures?.length)) {
                loadProviderList(listProvider)
                if (listProvider?.length === 1) {
                    setStaffId(listProvider[0]?.id);
                    handleSelectProvider(null, listProvider[0]?.id);
                    handleProviderContinueBtn()
                } else {
                    document
                        .querySelector('.providers__container')
                        ?.classList?.add('provider-in-booking');
                    renderContinueBtn();
                    providerListeners();
                    if (appointmentChannelId) {
                        document.querySelector('.providers__container .providerContinue__btn ')?.classList?.add('hide');
                    }
                    document
                        .querySelector('.providers__container .providerBack__btn')?.classList?.add('hiden');
                    navigate(SCREEN.PROVIDERS);
                }
            } else {
                if (listProvider?.length === 0) {
                    if (isFlowForCalendar) {
                        loadProviderList(listProvider);
                        navigate(SCREEN.PROVIDERS);
                        return
                    }
                    const div = document.querySelector('.notfound__container .screen__content')
                    if (div) {
                        div.textContent = 'Provider does not offer this location';
                    }
                    navigate(SCREEN.NOTFOUND_APPOINTMENT)
                    return
                }
                if (isPageHidden('patient_page', hiddenPages)) {
                    patientContinueBtnHandler()
                } else {
                    patientListeners();
                    navigate(SCREEN.PATIENTS);
                }
            }
            return
        }
        let staffIdList = staffProcedures?.map(
            (item) => item?.staff?.id
        );
        let filteredProviders = providers.filter(
            (e) => staffIdList?.indexOf(e.id) !== -1
        );

        const listProvider = filteredProviders.filter(
            (provider) => provider.location_ids?.includes(selectedLocation)
        )
        loadProviderList(listProvider);
        if (listProvider?.length === 1 || staffId) {
            handleSelectProvider(null, +staffId || listProvider[0]?.id);
            handleProviderContinueBtn()
        } else {
            document
                .querySelector('.providers__container')
                ?.classList?.add('provider-in-booking');
            renderContinueBtn();
            providerListeners();
            navigate(SCREEN.PROVIDERS);
        }

    } else {
        if (providers.length > 0) {
            const selectedProviders = providers.filter(
                (i) => i?.location_ids?.includes(selectedLocation)
            );
            const providerContainer = document.querySelector('.providers__container .list');
            if (providerContainer) {
                providerContainer.innerHTML = '';
            }
            loadProviderList(selectedProviders);
            setIsInstantQuote(true);
            renderContinueBtn();
            providerListeners();
            navigate(SCREEN.PROVIDERS);
        } else if (isInInstantQuote) {
            loadCategories(filterProcedures(procedures));
            loadProcedures(filterProcedures(procedures));
            navigate(SCREEN.SEE_ALL_SERVICES);
        }
    }
};